import styled from 'styled-components';
const ResultListStyled = styled.div`
  /* height: 100%; */
  flex-grow: 1;

  .MuiButtonBase-root {
    height: 40px;
    width: 40px;
  }

  .handle_btn {
    padding: 0 24px;
    justify-content: center;
    display: flex;

    .no-drop {
      cursor: not-allowed;
    }

    > div {
      margin-right: 15px;
    }

    .icon {
      /* fill: '#BDBDBD'; */
    }

    .preview {
      cursor: pointer;
    }
    .canClick {
      width: 18px;
      height: 18px;
      vertical-align: middle;
      /* fill: '#1B60AD'; */
      cursor: pointer;
    }
  }
`;
export default ResultListStyled;
